//
import * as React from 'react';
import { IndexRedirect, Route } from 'react-router';

import { CoachVoicePrototypeAppDynamic } from '@coursera-web/coach-voice-proto';

import { Route as CourseraRoute } from '@coursera/react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import homeRoutes from 'bundles/course-v2/homeRoutes';
import itemRoutes from 'bundles/item/routes';
import labsRoutes from 'bundles/launched-lab/components/lab-sandbox/routes';
import UserExperienceContextProvider from 'bundles/unified-common/providers/UserExperienceContextProvider';

const NotFound = loadOnRoute(() => import('bundles/phoenix/components/NotFound'));

const Course = loadOnRoute(() => import('bundles/course-v2/components/Course'));

/** Provides UserExperienceContext to the /learn route subtree so hooks like useEnableDayOneOnboarding get real org/selection data when orgScopedHome is on. */
const LearnRoutesUserExperienceProvider = (props: React.PropsWithChildren) => (
  <UserExperienceContextProvider>{props.children ?? null}</UserExperienceContextProvider>
);

const ItemGroupDescriptionPage = loadOnRoute(() => import('bundles/item/components/ItemGroupDescriptionPage'));
const S12NUpgradeDashboard = loadOnRoute(() => import('bundles/ondemand/components/s12n-upgrade/S12NUpgradeDashboard'));

const ActAsLearnerUnauthorizedPage = loadOnRoute(
  () => import('bundles/course-staff-impersonation/components/ActAsLearnerUnauthorizedPage')
);

// TODO: migrate CourseDataProvider to GraphQL / Naptime
const CourseDataProvider = loadOnRoute(() => import('bundles/course-v2/components/CourseDataProvider'));

const CoachVoicePrototype = loadOnRoute(CoachVoicePrototypeAppDynamic);

/**
 * These routes encompass all the possible routes for the in-course learner experience.
 * They are used to render the course home, item pages, and other course-specific pages.
 */
export default (
  <Route path="/learn" component={LearnRoutesUserExperienceProvider}>
    <Route path="specialization/upgrade/:s12nIds" getComponent={S12NUpgradeDashboard} />
    <CourseraRoute
      path=":courseSlug"
      getComponent={Course}
      handle={{
        tracking: {
          data: () => ({
            page: {
              segment: 'consumer',
              type: 'course_home',
            },
          }),
        },
      }}
    >
      {homeRoutes}

      {/* Temporary route for coach voice prototyping. To be deleted after prototyping experiment ends */}
      <Route path="coach-voice" name="coach-voice" getComponent={CoachVoicePrototype} />

      <Route path="act-as-learner-unauthorized" getComponent={ActAsLearnerUnauthorizedPage} />
      <CourseraRoute
        handle={{
          tracking: {
            data: () => {
              return {
                page: {
                  segment: 'consumer',
                  type: 'course_item',
                },
              };
            },
          },
        }}
      >
        <Route getComponent={CourseDataProvider}>
          {labsRoutes}
          <Route path="choices/:item_group_id" name="choices" getComponent={ItemGroupDescriptionPage} />
        </Route>

        {itemRoutes}
      </CourseraRoute>

      <IndexRedirect to="home/welcome" />
      <Route path="*" getComponent={NotFound} />
    </CourseraRoute>
  </Route>
);
